import { useState } from 'react';

import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Button, Checkbox, Menu, MenuItem, Typography } from '@mui/material';
import { Plan } from 'src/types/plans';

export default function PlansFilter({
  data,
  state,
  setState,
  INITIAL_STATE,
}: {
  data?: Plan[];
  state: any;
  setState: any;
  INITIAL_STATE: any;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCheck = (planId: number | number[]) => {
    setState((prev: any) => {
      if (Array.isArray(planId)) {
        return {
          ...prev,
          plans:
            state.plans.length === INITIAL_STATE.plans.length ? [] : planId,
        };
      }

      const newIds = state.plans.includes(planId)
        ? state.plans.filter((id: number) => id !== planId)
        : state.plans.concat(planId);

      return {
        ...prev,
        plans: newIds,
      };
    });
  };

  return (
    <>
      <Button
        id="plans-button"
        aria-controls={open ? 'lock-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        endIcon={
          <ExpandMoreRoundedIcon
            sx={{ transform: open ? 'rotate(180deg)' : 'unset' }}
          />
        }
        onClick={handleClickMenu}
        // disabled={disabled}
        sx={(theme) => ({
          color:
            state.plans.length > 0 &&
            state.plans.length !== INITIAL_STATE.plans.length
              ? theme.palette.primary.main
              : '#4F4F4F',
        })}>
        Planos:{' '}
        {state.plans.length === INITIAL_STATE.plans.length
          ? 'Todos'
          : state.plans.length > 0
            ? `+${state.plans.length}`
            : 'Nenhum'}
      </Button>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'plans-button',
          role: 'listbox',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            maxHeight: '40dvh',
            minWidth: '150px',
          },
        }}
        // aria-disabled={disabled}
      >
        <MenuItem
          sx={{
            display: 'flex',
            alignItems: 'center',
            '&.Mui-selected': {
              backgroundColor: '#F1F1F1',
            },
          }}
          selected={state.plans.length === INITIAL_STATE.plans.length}
          onClick={() => handleCheck(INITIAL_STATE.plans)}>
          <Checkbox
            checked={INITIAL_STATE.plans.length === state.plans.length}
            inputProps={{ 'aria-label': 'checkbox' }}
            color="secondary"
            size="small"
          />
          <Typography fontSize={14} fontWeight={700} color={'#000'}>
            Todos
          </Typography>
        </MenuItem>
        {data &&
          data.map((plan, index) => (
            <MenuItem
              key={index}
              sx={{ display: 'flex', alignItems: 'center' }}
              onClick={() => handleCheck(plan.id)}>
              <Checkbox
                checked={state.plans.includes(plan.id)}
                inputProps={{ 'aria-label': 'checkbox' }}
                color="primary"
                size="small"
              />
              <Typography fontSize={12} fontWeight={600} color={'#000'}>
                {plan.name}
              </Typography>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}
